import { render, staticRenderFns } from "./OrderInquiry.vue?vue&type=template&id=2ced09e4&scoped=true&"
import script from "./OrderInquiry.vue?vue&type=script&lang=js&"
export * from "./OrderInquiry.vue?vue&type=script&lang=js&"
import style0 from "./OrderInquiry.vue?vue&type=style&index=0&id=2ced09e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced09e4",
  null
  
)

export default component.exports